import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import PartnerNode from './partner-node';
import TermsCriteriaNode from './terms-criteria-node';
import { JiraFlatButton } from '../../../tc-ui/small-buttons';

const Buyer = (props) => {
  const {
    contractorEditable,
    supplierEditable,
    isPartner,
    partners,
    contacts,
    locationId,
    propsForTermsCriteria,
    from = {},
    to = {},
  } = props;
  const buyerIsSender = Boolean(!locationId);
  return (
    <div style={{
      overflow: 'auto',
      paddingRight: '4%',
      width: '50%',
      margin: '8px 0',
      float: 'right',
      fontSize: '14px',
    }}
    >
      <div
        style={{
          marginLeft: '10%',
          width: '85%',
          padding: '24px',
          border: '1px solid #e0e0e0',
          borderRadius: '5px',
        }}
      >
        <b>{buyerIsSender ? 'Buyer' : 'Contract prepared for:'}</b>
        {
          buyerIsSender ? (
            <div>
              {from.emailAlias || from.email}
            </div>
          ) : (
            <div>
              {to.name}
            </div>
          )
        }
        {
          isPartner
          && (
            <div style={{ marginTop: '8px' }}>
              <PartnerNode
                isReceiver={!buyerIsSender}
                partners={partners}
                contacts={contacts}
              />
            </div>
          )
        }
      </div>
      <TermsCriteriaNode
        editable={!supplierEditable && contractorEditable}
        {...propsForTermsCriteria}
      />
    </div>
  );
};

Buyer.propTypes = {
  contractorEditable: PropTypes.bool,
  resendContract: PropTypes.func,
  supplierEditable: PropTypes.bool,
  isPartner: PropTypes.bool,
  partner: PropTypes.object,
  propsForTermsCriteria: PropTypes.object,
};

const mapState = ({
  contracting: {
    contractActivitiesProducts,
  },
}) => {
  const rightSideContent = contractActivitiesProducts.get('rightSideContent').toJS();
  const leftNav = contractActivitiesProducts.get('leftNav').toJS();

  return {
    isPartner: leftNav.viewingAs === 'Supplier',
    partners: leftNav.partners,
    contacts: leftNav.contacts,
    locationId: leftNav.locationId,
    contractorEditable: leftNav.contractorEditable,
    supplierEditable: leftNav.supplierEditable,
    contractId: leftNav.contractId,
    from: leftNav.from,
    to: leftNav.to,
    toEmails: leftNav.toEmails,
    propsForTermsCriteria: {
      ...rightSideContent.buyerInfo,
      deadlineDate: rightSideContent.deadlineDate,
      contractState: leftNav.contractState,
    },
  };
};


export default connect(mapState)(Buyer);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-policies/buyer.jsx